<template>
    <div class="main-background">
            <div class="filter-page-container">
          <div class="filter-page-back-button" @click="returnToLastPage">
            <chevron-left-icon class="back-button-icon"/>
            <p class="back-button-text">Фільтри</p>
          </div>
          <div class="filter-category-container">
            <p class="filter-category-title">Категорії</p>
            <div class="filter-category-list">
                <div :class="`filter-category-item ${checkedCategory.includes(category.id) && 'active'}`" 
                @click="setCheckCategory(category.id)"
                v-for="category of allHeaderCategories" 
                :key="category.id">
                {{ category.name }}
                </div>
            </div>
          </div>
          <div class="bottom-filter-button-container">
                <button 
                class="filtration-button" 
                @click="setFilterProducts"
                >
                Фільтрувати
            </button>
          </div>
        </div>
    </div>
</template>

<script>

import { ChevronLeftIcon } from 'vue-feather-icons'
import { mapMutations } from "vuex"

export default {
    name: "filter-page",
    components: {
        ChevronLeftIcon,
    },
    props: {
        categories: {
            type: Array,
            required: true
        },
        isShowPage: {
            type: String,
            required: true
        }
    },
    data() {
        return {
          carouselItems: [],
          checkedCategory: [],
        }
    },
    mounted() {

    },
      computed: {
        allHeaderCategories() {
            return this.$store.getters.allHeaderCategories;
        },
         allCategories() {
            return this.$store.getters.allCategories
        },
        perPageName() {
            return this.$store.getters.perPageName
        },
        getMaxPrice() {
            return this.$store.getters.getMaxPrice
        },
        getFilterParametrs() {
            return this.$store.getters.getFilterParametrs
        }
    },
    methods: {
        ...mapMutations(['setFilterParametrs','deleteFilterCategoryParametr', 'deleteFilterParametr', 'setFilterPriceParametrs', 'addPerPage']),
        setFilterProducts() {
            if (this.checkedCategory.length) {
                let data = {
                    q: '',
                    category_ids: this.checkedCategory.join(','),
                    sort: ''
                    };
                this.$store.dispatch("searchedProducts", data);
            } else {
                this.$store.dispatch('getAllProducts')
            }
            this.$emit('setIsChangePage', 'home')
        },
        setChangePriceCounter(price, value) {
            let data
            if (value === 'max') {
                data = {
                    category_ids: this.checkedCategory.length ? this.checkedCategory : null,
                    price_from: this.inputMinimum,
                    price_to: Number(price)
                }
            } else {
                 data = {
                    category_ids: this.checkedCategory.length ? this.checkedCategory : null,
                    price_from: Number(price),
                    price_to: this.inputMax
                }
            }
            this.setFilterParametrs(data)
        },
        returnToLastPage() {
            if (this.perPageName === 'product') {
                this.$emit('setIsChangePage', 'product')
            } else {
                this.$emit('setIsChangePage', 'home')
            }
            this.addPerPage('')
            this.deleteFilterParametr()
        },
        setCheckCategory(value) {
                if (this.checkedCategory.includes(value)) {
        this.checkedCategory.splice(this.checkedCategory.indexOf(value), 1);
      } else {
        this.checkedCategory = [...this.checkedCategory, value]
      }
        },
        setChangePrice(value) {
            this.inputMinimum = value[0]
            this.inputMax = value[1]
        }
    },
    watch: {
       inputMinimum(newValue, oldValue) {
        let val = oldValue
        val
        this.setChangePriceCounter(newValue, 'min')
       },
       inputMax(newValue, oldValue) {
        let val = oldValue
        val
        this.setChangePriceCounter(newValue, 'max')
        },  
    }
}
</script>

<style scoped>
.main-background {
    background: #121212;
    padding-left: 16px;
    padding-right: 16px;
}
.filter-page-back-button {
    position: relative;
    border-bottom: 1px solid #1D1D1D;
    padding: 18px;
    cursor: pointer;
}
.back-button-icon {
    position: absolute;
    color: #fff;
}
.back-button-text {
    color: #FFF;
    text-align: center;
    font-family: "Comfortaa";
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
}

.filter-category-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 16px;
}

.filter-category-title {
    color: #FFF;
    font-family: "Comfortaa";
    font-size: 16px;
    font-weight: 500;
    line-height: normal;
    margin-top: 20px;
}

.bottom-filter-button-container {
  background: #121212;
  box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.04);
  padding: 16px 0;
}

.filtration-button {
    padding: 12px;
    width: 100%;
    border-radius: 8px;
    background: #1E7CE9;
    color: #FFF;
    text-align: center;
    font-family: 'Comfortaa', sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    border: none;
}
.filter-page-container {
    display: flex;
    flex-direction: column;
    height: 100vh;
}

.bottom-filter-all-product {
 color: #707070;
font-family: Inter;
font-size: 10px;
font-weight: 500;
line-height: 20px;
padding-left: 16px;
margin-top: auto;
}

.filter-category-item {
  border-radius: 16px;
  border: 2px solid #FFF;
  color: #fff;
  text-align: center;
  font-family: "Comfortaa", sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  padding: 7px 10px;
  cursor: pointer;
}

.filter-category-item.active {
  background: #fff;
  color: #121212;
}

</style>